//zh.js
import ruLocale from 'element-ui/lib/locale/lang/ru-RU'
import ruJson from '../locales/ru.json'
const ru = {
    ...ruJson["ru"],
    ...ruLocale
}

export default ru